import type { AdminEpisodeDetail, AdminShot } from "@storyline/shared";

export type OrderedShot = {
	shot: AdminShot;
	nodeTitle: string;
	label: string;
};

export const orderedShots = (episode: AdminEpisodeDetail): OrderedShot[] => {
	const ordered: OrderedShot[] = [];
	const nodes = episode.nodes.slice().sort((a, b) => a.orderIndex - b.orderIndex);
	for (const node of nodes) {
		const shots = node.shots.slice().sort((a, b) => a.orderIndex - b.orderIndex);
		shots.forEach((shot, index) => {
			ordered.push({ shot, nodeTitle: node.title, label: `${node.title} · plan ${index + 1}` });
		});
	}
	return ordered;
};
